var map = {
	"./bank.svg": "1eb0",
	"./cash.svg": "5f0f",
	"./dynamic.svg": "6ee9",
	"./fixed.svg": "9c21",
	"./online.svg": "af50",
	"./pos.svg": "6e00"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b2cd";